<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer024">
<p class="Body_Heading2B">Also by David Kundtz</p>
<p class="Body_List--Centered-"><span class="Italic _idGenCharOverride-1">The Art of Stopping: How to Be Still When You Have to </span><span class="noBreak"><span class="Italic _idGenCharOverride-1">Keep Going</span></span></p>
<p class="Body_List--Centered-"><span class="Italic _idGenCharOverride-1">Quiet Mind: One Minute M</span><span class="noBreak"><span class="Italic _idGenCharOverride-1">indfulness</span></span></p>
<p class="Body_List--Centered-"><span class="Italic _idGenCharOverride-1">Awakened Mind: One Minute Wak</span><span class="noBreak"><span class="Italic _idGenCharOverride-1">e Up Calls</span></span></p>
<p class="Body_List--Centered-"><span class="Italic _idGenCharOverride-1">Being Present: A Book of Daily R</span><span class="noBreak"><span class="Italic _idGenCharOverride-1">eflections</span></span></p>
<p class="Body_List--Centered- _idGenParaOverride-1"><span class="Italic _idGenCharOverride-1">Coming To: A Biom</span><span class="noBreak"><span class="Italic _idGenCharOverride-1">ythography</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NothingsWrong.vue?372a4f22